import { ConnectFlowSurveyQuestionModel } from '@/types';

export interface ConnectFlowSurveyQuestionAnswerModel {
    id: number;
    label: number;
    rangeAnswer: string;
    value: number;
    question: ConnectFlowSurveyQuestionModel;
}
